module.exports = __webpack_public_path__ + "img/ring_0_0_1_0@3x.daf66be9.png";